
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/month_view/templates/calendar_layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='month-view'>\n  <div class=\"month-view-header\">\n    <div class=\"month-view-display-mode\"></div>\n    <div class=\"month-view-nav\">\n      <div class=\"month-view-previousMonth\"></div>\n      <h2 class=\"month-view-viewTitle\"></h2>\n      <div class=\"month-view-nextMonth\"></div>\n    </div>\n  </div>\n  <div class='month-view-region'></div>\n  <div class='loading-view-region'></div>\n</div>\n";
},"useData":true});
    }).call(this);
  